/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const workInfoCompanyQuery = params => {
  return axios.post(`${base}/work_info_company/query`, params)
}

export const workInfoCompanyCreate = params => {
  return axios.post(`${base}/work_info_company/create`, params)
}

export const workInfoCompanyEdit = params => {
  return axios.post(`${base}/work_info_company/${params.id}/edit`, params)
}

export const workInfoCompanyGet = id => {
  return axios.get(`${base}/work_info_company/${id}`)
}

export const workInfoCompanyDelete = id => {
  return axios.post(`${base}/work_info_company/${id}/delete`)
}




// WEBPACK FOOTER //
// ./src/views/work-info-company/work-info-company.api.js